import React, { useState } from 'react'
import { FormControl, TextField, Typography } from '@mui/material';

const TableColumn = (props) => {
    const { renders={}, column } = props 
    const [_, forceUpate] = useState({});
    const render = () => forceUpate({})
    renders.render = render
    
    return (
        true
            ? <Typography sx={{
                minWidth: '100px',
                fontWeight: 600,
                textAlign : 'center'
            }}>{column?.name}</Typography>
            : (
                <FormControl>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label={!column?.isReadOnly ? `Enter ${column?.value}` : ""}
                        value={column?.name}
                        onChange={(e) => { column.name = e?.target?.value; render() }}
                        InputProps={{
                            readOnly: column?.isReadOnly
                        }}
                        sx={{
                            "&.Mui-disabled fieldset": {
                                border: "none",
                            },
                            "& .MuiOutlinedInput-root input[readonly] ~ fieldset": {
                                border: "none",
                            },
                            minWidth: '100px'
                        }}
                    />
                </FormControl>
            )
    )
}

export default TableColumn
